import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale010,
  scale020,
  scale080,
  scale100,
  scale150,
  scale170,
  scale190,
  scale200,
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  xdlColorHoverSecondary,
} from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  background-color: ${xdlColorHoverSecondary};
  margin: 0 -${scale100} calc(${scale020} + ${scale200});
  padding: ${scale150};

  @media ${mediaConfined} {
    border-radius: ${scale080};
    margin: 0 0 calc(${scale020} + ${scale200});
    padding: ${spaceXL};
  }
`;

export const ArticlesContainer = styled.div`
  margin-bottom: ${spaceXL};

  @media ${mediaConfined} {
    margin-bottom: 0;

    & > div {
      &:first-child {
        border-radius: ${scale080} ${scale080} 0 0;
      }
      &:not(:first-child):not(:last-child) {
        border-radius: 0;
      }
      &:last-child {
        border-radius: 0 0 ${scale080} ${scale080};
      }
    }
  }
`;

export const RegistrationContainer = styled.div`
  text-align: center;

  @media ${mediaConfined} {
    align-items: center;
    display: flex;
    padding: ${spaceXL} ${scale170};
    text-align: left;

    & > svg {
      height: 92px;
      margin: calc(${scale010} + ${scale100}) calc(${scale020} + ${scale190})
        calc(${scale010} + ${scale100}) calc(${scale010} + ${scale150});
      width: 92px;
    }
  }
`;

export const RightWrapper = styled.div`
  @media ${mediaConfined} {
    flex: 1;
  }
`;

export const Title = styled(Headline)`
  margin: ${spaceM} 0 ${spaceS};
`;

export const Text = styled(BodyCopy)`
  margin-bottom: ${spaceL};
`;
